export default __webpack_public_path__ + "assets/fog-night.58a5eb74.svg";